import * as React from 'react';
import { IEstimateTimeProps } from './types';
import { v4 as uuidv4 } from 'uuid';
import { ESTIMATE_OPTIONS, ESTIMATE_TIME_TEXT } from '../../constants';
import { CLASS_BOARD_DETAILS } from '../../../../constants';
import './_EstimateTime.scss';
import { Select } from 'kui';
import { ISelectActiveInheritedProps } from 'kui';

export function EstimateTime ({
    text,
    value,
    allowChangeEstimateTime,
    onChange,
    onShowBoardLimitSnackbarIfNeeded,
}: IEstimateTimeProps){
    const [key, setKey] = React.useState(uuidv4());
    const className = CLASS_BOARD_DETAILS + '__estimate-time';

    function onClose() {
        setKey(uuidv4())
    }

    const onChangeHandler = (
        event: ISelectActiveInheritedProps
    ) => {
        onChange(event.item.value);
    }

    return (
        <div className={CLASS_BOARD_DETAILS + '__estimate-time'}>
            <div className={className + '-text'}>
                {ESTIMATE_TIME_TEXT}
            </div>
            <div className={CLASS_BOARD_DETAILS + '__estimate-time-wrapper'} onClick={onShowBoardLimitSnackbarIfNeeded}>
                <Select
                    className={className + '-select'}
                    active={ESTIMATE_OPTIONS.findIndex(o => o.value === value)}
                    directionVertical={'auto'}
                    disabled={!allowChangeEstimateTime}
                    dropdownClassName={CLASS_BOARD_DETAILS + '-dropdown'}
                    key={key}
                    options={ESTIMATE_OPTIONS}
                    value={text}
                    variant={'arrow'}
                    onClose={onClose}
                    onChange={onChangeHandler}
                />
            </div>
        </div>
    );
}
